import { render, staticRenderFns } from "./LodgeComplaint.vue?vue&type=template&id=1ef9478b&scoped=true&"
import script from "./LodgeComplaint.vue?vue&type=script&lang=js&"
export * from "./LodgeComplaint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef9478b",
  null
  
)

export default component.exports